// extracted by mini-css-extract-plugin
export default {"modal":"BetLiveModal_modal__cwbnp","modalOverlay":"BetLiveModal_modalOverlay__hcyYE","phoneNumber":"BetLiveModal_phoneNumber__FGNxd","fastCode":"BetLiveModal_fastCode__Biw7n"};